module.exports = __webpack_public_path__ + "img/hr-level3addon_running_gun.8c31ab9f.png";